import { cn } from '@/lib/utils'

interface Props {
  color?: string
  width?: number
  height?: number
  direction?: 'down' | 'up'
}

export const DropDownArrowIcon = ({
  color = '#6F6F6F',
  width = 23,
  height = 13,
  direction = 'down',
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('transition-transform duration-200', direction === 'up' && 'rotate-180')}>
      <path
        d="M1 0.5L11.5 11.5L22 0.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
